<template>
  <section
    id="about"
    class="overflow-hidden"
  >
    <v-row
      class="white"
      no-gutters
    >
      <v-col
        class="pa-5"
        cols="12"
        md="6"
      >
        <base-bubble-1 style="transform: translate(5%, -5%)" />

        <base-heading class="info--text">
          About Me
        </base-heading>

        <base-text class="mb-5">
          By day I write software code for a major tech platform used by major companies and government agencies<br>
          By night I binge watch TV with my family<br>
          Occasionally I work on side projects that I think will make me rich someday<br>
          And above all, I have always been a huge nerd
        </base-text>

        <base-subheading class="info--text">
          Biography
        </base-subheading>

        <base-text class="mb-5">
          Over 40 (that's old, right?)<br>
          Self-educated<br>
          East-coast US born and raised
        </base-text>

        <v-alert
          outlined
          color="info"
        >
          <v-row
            v-for="(skill, i) in skills"
            :key="i"
            style="color: #69A1BB;"
          >
            <v-col
              class="text-uppercase"
              cols="6"
              v-text="skill.name"
            />

            <v-col
              class="text-right"
              cols="6"
              v-text="`${skill.value}%`"
            />

            <v-progress-linear
              :value="skill.value"
              color="info"
              height="8"
            />
          </v-row>
        </v-alert>
      </v-col>

      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/aboutme.png')"
          height="100%"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
  export default {
    data: () => ({
      skills: [
        {
          name: 'Fake Statistic #1',
          value: 100,
        },
        {
          name: 'Fake Statistic #2',
          value: 75,
        },
        {
          name: 'Totally Real Statistic',
          value: 90,
        },
      ],
    }),
  }
</script>
